import React from 'react';
import QuotationList from '../components/QuotationList';

const ServiceQuotations: React.FC = () => (
  <QuotationList quotationType="service" title="Xizmat takliflari" icon="🛠️" />
);

export default ServiceQuotations;
